const $4de3ae5bfc4cbd95$export$cf2f3e61415286a7 = (data)=>{
    const { fullname: fullname } = data;
    return `
    \u{203B}\u{3053}\u{306E}\u{30E1}\u{30FC}\u{30EB}\u{306F}\u{30B7}\u{30B9}\u{30C6}\u{30E0}\u{304B}\u{3089}\u{306E}\u{81EA}\u{52D5}\u{8FD4}\u{4FE1}\u{3067}\u{3059}

    ${fullname} \u{69D8}

    \u{304A}\u{4E16}\u{8A71}\u{306B}\u{306A}\u{3063}\u{3066}\u{304A}\u{308A}\u{307E}\u{3059}\u{3002}
    \u{5927}\u{6D0B}\u{7D19}\u{696D}\u{682A}\u{5F0F}\u{4F1A}\u{793E}\u{3067}\u{3054}\u{3056}\u{3044}\u{307E}\u{3059}\u{3002}
    \u{3053}\u{306E}\u{5EA6}\u{306F}\u{3001}\u{5F0A}\u{793E}\u{30B5}\u{30FC}\u{30D3}\u{30B9}E-Biss Factory\u{306B}\u{3064}\u{3044}\u{3066}\u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{3044}\u{305F}\u{3060}\u{304D}\u{8AA0}\u{306B}\u{3042}\u{308A}\u{304C}\u{3068}\u{3046}\u{3054}\u{3056}\u{3044}\u{307E}\u{3059}\u{3002}
    \u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{3044}\u{305F}\u{3060}\u{3044}\u{305F}\u{5185}\u{5BB9}\u{3092}\u{78BA}\u{8A8D}\u{3057}\u{3001}\u{5F8C}\u{307B}\u{3069}\u{62C5}\u{5F53}\u{3088}\u{308A}\u{3054}\u{9023}\u{7D61}\u{3055}\u{305B}\u{3066}\u{3044}\u{305F}\u{3060}\u{304D}\u{307E}\u{3059}\u{306E}\u{3067}\u{4ECA}\u{3057}\u{3070}\u{3089}\u{304F}\u{304A}\u{5F85}\u{3061}\u{304F}\u{3060}\u{3055}\u{3044}\u{307E}\u{305B}\u{3002}

    \u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}
    \u{5927}\u{6D0B}\u{7D19}\u{696D}\u{682A}\u{5F0F}\u{4F1A}\u{793E}
    \u{4F4F}\u{6240}\u{FF1A}\u{3012}660-0807\u{3000}\u{5175}\u{5EAB}\u{770C}\u{5C3C}\u{5D0E}\u{5E02}\u{9577}\u{6D32}\u{897F}\u{901A}2-9-15
    \u{96FB}\u{8A71}\u{756A}\u{53F7}\u{FF1A}06-6415-7877
    \u{55B6}\u{696D}\u{6642}\u{9593}\u{FF1A}\u{5E73}\u{65E5} 9\u{6642}\u{FF5E}17\u{6642}
    \u{30E1}\u{30FC}\u{30EB}\u{FF1A}info@taiyo-gr.jp
    \u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}\u{2014}
    `;
};
const $4de3ae5bfc4cbd95$export$fc90def2cbba7d6 = (data)=>{
    const { fullname: fullname, company: company, department: department, email: email, tel: tel, body: body } = data;
    return `
    ${company} ${fullname}\u{69D8}\u{304B}\u{3089}\u{306E}\u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}

    \u{90E8}\u{7F72}\u{540D}: ${department}
    \u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}: ${email}
    \u{96FB}\u{8A71}\u{756A}\u{53F7}: ${tel}
    \u{672C}\u{6587}:
    ${body}

    \u{62C5}\u{5F53}\u{8005}\u{306E}\u{65B9}\u{306F}\u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{5185}\u{5BB9}\u{3092}\u{78BA}\u{8A8D}\u{306E}\u{4E0A}\u{3001}\u{8A18}\u{8F09}\u{306E}\u{30E1}\u{30FC}\u{30EB}\u{30A2}\u{30C9}\u{30EC}\u{30B9}\u{306B}\u{56DE}\u{7B54}\u{3092}\u{304A}\u{9858}\u{3044}\u{3044}\u{305F}\u{3057}\u{307E}\u{3059}\u{3002}
  `;
};


// メール送信APIの認証情報
const $4e0121083111d59a$var$user = undefined;
const $4e0121083111d59a$var$password = undefined;
// 入力情報の取得
const $4e0121083111d59a$var$getFormData = ()=>{
    const fullname = document.getElementById("contact-name").value;
    const company = document.getElementById("contact-company").value;
    const department = document.getElementById("contact-department").value;
    const email = document.getElementById("contact-email").value;
    const tel = document.getElementById("contact-tel").value;
    const body = document.getElementById("contact-body").value;
    return {
        fullname: fullname,
        company: company,
        department: department,
        email: email,
        tel: tel,
        body: body
    };
};
// 入力データのバリデーション（戻り値: boolean）
const $4e0121083111d59a$var$formValidation = (formData)=>{
    const { fullname: fullname, company: company, department: department, email: email, tel: tel, body: body } = formData;
    // 状態をリセット
    document.querySelector("#error-fullname").dataset.isShow = "false";
    document.querySelector("#error-company").dataset.isShow = "false";
    document.querySelector("#error-department").dataset.isShow = "false";
    document.querySelector("#error-email").dataset.isShow = "false";
    document.querySelector("#error-tel").dataset.isShow = "false";
    document.querySelector("#error-body").dataset.isShow = "false";
    // バリデーションチェック用のフラグ
    let checkFormData = true;
    // メールアドレス確認用の正規表現
    const emailRegex = new RegExp("^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*.)+[a-zA-Z]{2,}$");
    if (!fullname) {
        document.querySelector("#error-fullname").dataset.isShow = "true";
        checkFormData = false;
    }
    if (!company) {
        document.querySelector("#error-company").dataset.isShow = "true";
        checkFormData = false;
    }
    if (!department) {
        document.querySelector("#error-department").dataset.isShow = "true";
        checkFormData = false;
    }
    if (!email || !emailRegex.test(email)) {
        document.querySelector("#error-email").dataset.isShow = "true";
        checkFormData = false;
    }
    if (!tel) {
        document.querySelector("#error-tel").dataset.isShow = "true";
        checkFormData = false;
    }
    if (!body) {
        document.querySelector("#error-body").dataset.isShow = "true";
        checkFormData = false;
    }
    return checkFormData;
};
// 自動返信メール送信
const $4e0121083111d59a$var$sendAutoResponseMail = async (formData)=>{
    if (!$4e0121083111d59a$var$user || !$4e0121083111d59a$var$password) return;
    const { email: email } = formData;
    // メール送信
    await fetch(undefined, {
        method: "POST",
        headers: {
            Authorization: `Basic ${btoa(`${$4e0121083111d59a$var$user}:${$4e0121083111d59a$var$password}`)}`
        },
        body: JSON.stringify({
            from: undefined,
            to: email,
            subject: "\u304A\u554F\u3044\u5408\u308F\u305B\u3092\u53D7\u3051\u4ED8\u3051\u307E\u3057\u305F",
            text: (0, $4de3ae5bfc4cbd95$export$cf2f3e61415286a7)(formData)
        })
    }).then(()=>{
        return true;
    }).catch(()=>{
        return false;
    });
};
// 通知メール送信
const $4e0121083111d59a$var$sendNotificationMail = async (formData)=>{
    if (!$4e0121083111d59a$var$user || !$4e0121083111d59a$var$password) return;
    // メール送信
    await fetch(undefined, {
        method: "POST",
        headers: {
            Authorization: `Basic ${btoa(`${$4e0121083111d59a$var$user}:${$4e0121083111d59a$var$password}`)}`
        },
        body: JSON.stringify({
            from: "E-biss Factory \u30B5\u30FC\u30D3\u30B9\u30B5\u30A4\u30C8",
            to: undefined,
            subject: "\u3010E-Biss Factory\u3011\u304A\u554F\u3044\u5408\u308F\u305B\u3092\u53D7\u4FE1\u3057\u307E\u3057\u305F",
            text: (0, $4de3ae5bfc4cbd95$export$fc90def2cbba7d6)(formData)
        })
    }).then(()=>{
        return true;
    }).catch(()=>{
        return false;
    });
};
// submit buttonの無効化
const $4e0121083111d59a$var$invalidateSubmitButton = ()=>{
    const buttonElem = document.getElementById("submit-button");
    buttonElem.disabled = true;
    buttonElem.value = "\u9001\u4FE1\u4E2D...";
};
const $4e0121083111d59a$var$onSubmit = async ()=>{
    // フォームデータの取得
    const formData = $4e0121083111d59a$var$getFormData();
    // 入力内容のチェック
    if ($4e0121083111d59a$var$formValidation(formData)) {
        $4e0121083111d59a$var$invalidateSubmitButton(); // 複数回クリック対策
        await $4e0121083111d59a$var$sendAutoResponseMail(formData); // 自動返信メール送信
        await $4e0121083111d59a$var$sendNotificationMail(formData); // お問い合わせ通知メール送信
        window.location.href = "/complete.html"; // 完了ページにリダイレクト
    } else {
        document.getElementById("submit-button").disabled = false;
        window.scrollTo({
            top: 0
        });
    }
};
document.getElementById("submit-button").addEventListener("click", $4e0121083111d59a$var$onSubmit);


//# sourceMappingURL=contact.d2641c1a.js.map
